import { AdministratorDto } from './AdministratorDto';

export type NoticeCategory = 'common' | 'community';

export default class NoticeDto {
  id: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  title: string;
  contents: string;
  showedYn: boolean;
  fixedTopYn: boolean;
  categoryType: NoticeCategory;
  serviceType: 'EARTH_APP';
  viewCount: number;
  administrator: AdministratorDto;
}
